<template>
  <div class="editor-cropper-container">
    <transition name="fade">
      <div
        v-if="visible"
        class="background-cover"
        @click="hide"
      ></div>
    </transition>
    <transition name="scale">
      <div
        v-if="visible"
        class="cropper-content"
      >
        <div class="title">{{ title }}</div>
        <div class="cropper-box">
          <vueCropper
            style="background: transparent"
            ref="cropper"
            :img="option.img"
            :canMove="option.canMove"
            :autoCrop="option.autoCrop"
            :centerBox="option.centerBox"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
          ></vueCropper>
        </div>
        <CompleteButton
          text="完成"
          style="margin-top: 16px"
          @clickBtn="clickCompleteBtn"
        />
      </div>
    </transition>
  </div>
</template>
<script>
const { VueCropper } = require('vue-cropper');
import CompleteButton from '../CompleteButton/CompleteButton.vue';

export default {
  name: 'message',
  components: {
    VueCropper,
    CompleteButton,
  },
  data() {
    return {
      visible: false,
      optionValue: 2,
      type: 1,
      option: {
        img: this.img || '', // 裁剪图片的地址
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: this.fixedNumber || [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
    };
  },
  props: {
    title: {
      //图片标题
      type: String,
      default: '',
    },
  },
  methods: {
    // 上传
    async clickCompleteBtn() {
      this.$refs.cropper.getCropData(async (file) => {
        this.$emit('uploadConfirm', file);
        this.visible = false;
      });
    },
    show(options) {
      this.visible = true;
      this.option.img = options.img;
      this.option.fixedNumber = options.fixedNumber || [1, 1];
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.editor-cropper-container {
  .background-cover {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 299;
    background: rgba(0, 0, 0, 0.5);
  }
  .cropper-content {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 301;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 500px;
    height: 486px;
    padding: 32px 0;
    background-color: $form-bg-color;
    box-sizing: border-box;
    border-radius: 12px;
    .title {
      font-size: 18px;
      color: $confirm-title-color;
      margin-bottom: 32px;
    }
    .cropper-box {
      width: 318px;
      height: 318px;
      border-radius: 6px;
      :deep(.vue-cropper) {
        height: 318px;
        .cropper-modal {
          background: #000;
          height: 318px;
          border-radius: 6px;
        }
      }
    }
  }
}
</style>
